<template>
  <div>
    <div class="third-rea">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="searchInput">查询</el-button>
          <el-button class="btn-two" type="default" @click="resetInput">重置</el-button>
          <span class="btn-shu"></span>
          <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
        </div>
      </div>
      <div class="third-search">
        <el-form :inline="true" :model="formInline" label-width="76px" @keyup.native.enter="searchInput">
          <div class="search-row">
              <div class="row-item">
                <el-form-item label="服务名称">
                  <el-input class="item-input" :maxlength="30" v-model="formInline.serviceName" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="使用环境">
                  <el-select class="item-input" v-model="formInline.userEnvironment" clearable placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in SYHJoptions"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="row-item">
                  <el-form-item label="接入方式">
                    <el-select class="item-input" v-model="formInline.accessWay" clearable placeholder="请选择">
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in JRFSoptions"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="服务状态">
                  <el-select class="item-input" v-model="formInline.status" clearable placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已下架" value="0"></el-option>
                    <el-option label="已上架" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one service-listTwo">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button class="do-btn-four" type="default" icon="el-icon-plus" @click="addPage">新增</el-button>
        </div>
        <div class="do-btn-right">
          <div class="do-btn-check">
            <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
            <span class="btn-check-span">显示高级功能</span>
          </div>
          <div class="do-btn-hign-list" v-if="checked">
            <!-- 展示字段 -->
            <sort-data
              :tableRow="tableRow"
              @showList="getTableList"
              sessionOriginalName="serviceListSortOrignalData"
              sessionResultName="serviceListSortData"
            ></sort-data>
            <!-- 数据顺序 -->
            <display-field
              :selectList="tableRow"
              sessionOriginalName="serviceListDisplayFiedOrignal"
              @setDataOrder="getDataOrder"
              sessionResultName="serviceListDisplayFied"
            ></display-field>
          </div>
        </div>
      </div>
      <el-table
        class="third-tableThree tableThree-heightOthTwo"
        :data="tableData"
        border
        stripe
        @selection-change="handleSelectChange"
        row-key="otherUserId"
        ref="otherUserId"
        v-loading="loading"
        >
        <el-table-column
          type="selection"
          width="32px"
          reserve-selection>
        </el-table-column>
        <template v-for="(item, index) in tableDataShow">
          <el-table-column
            min-width="100px"
            :prop="item.key"
            :label="item.column"
            :key="index"
            :show-overflow-tooltip="true">
             <template  slot-scope="scope">
               <span
                v-if="item.key === 'service_icon'"
                class="bigImg" @click="viewImage(scope.row.service_icon)"
               >
                查看图片
               </span>
               <span
                v-else 
                :class="{
                  redCorlo: isStatus(scope.row, item.key) === 0,
                  greenCorlo: isStatus(scope.row, item.key) === 1,
                }">
                  {{ getlable(scope.row, item.key) }}
                </span>
             </template>
          </el-table-column>
        </template>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="updateStatus(scope.row)"
              type="text"
              size="small">
              {{ scope.row.status === 0 ? '上架' : '下架' }}
            </el-button>
            <span class="tableThree-height-shu">
              <span class="shu-item"></span>
            </span>
            <el-button
              @click="changeComponent(scope.row, 'particulars')"
              type="text"
              size="small">
              详情
            </el-button>
            <span class="tableThree-height-shu">
              <span class="shu-item"></span>
            </span>
            <el-button
              :disabled="scope.row.status === 1"
              type="text"
              @click="changeComponent(scope.row, 'DetailsInfo')"
              size="small">
              编辑
            </el-button>
            <span class="tableThree-height-shu">
              <span class="shu-item"></span>
            </span>
            <el-button
              :disabled="scope.row.status === 1"
              type="text"
              size="small"
              @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="third-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <hign-modal :hignModalVisible="hignModal" @searchModal="toHignSearch" @cancelModal="closeModal" :hignOneList="tableRow"></hign-modal>
    <notice-modal :noticeModalVisible="noticeModal" @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent">
    </notice-modal>

    <el-dialog class="serviceDialog" title="查看图片" :visible.sync="ImgDialog" v-el-drag-dialog :close-on-click-modal='false'>
      <img :src="imgSrc" alt="">
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="ImgDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getStore, setStore } from "@/utils/store";

export default {
  name: 'thirdThree',
  data() {
    return {
      loading: false,
      ImgDialog: false, // 查看图片弹窗
      imgSrc: '',
      detailModal: false, // 详情弹窗
      noticeDispatch: '', // 弹窗提交类型 status: 状态 del：删除
      noticeSpec: '', // 标红提示
      noticeType: 1, // 提示类型
      agreeContent: '我知道了', // 提示弹窗确认按钮内容
      noticeTitle: '这是一条警告提示', // 提示
      noitceContent: '一些失败/警告的原因内容', // 提示信息
      noticeModal: false, // 提示弹窗
      pageSize: 40,
      pageIndex: 1,
      totalNum: 0, // 总数
      tableData: [],
      hignModal: false, // 高级搜索
      formInline: {
        serviceName: '', // 服务名称
        userEnvironment: '', // 使用环境id
        accessWay: '', // 接入方式id
        status: '', // 状态:0下架 1上架
      },
      selectArrList: [], // 批量移除
      nowSelectArr: [], // 移除数组
      isDeleteList: false, // 是否批量删除
      hignSearchRes: '', // 高级检索条件
      tableDataShow: [
        {
          column: '使用环境',
          key: 'userEnvironment',
          needKeyValue: true,
          caseKey: 'userEnvironment'
        },
        {
          column: '服务名称',
          key: 'service_name',
          needKeyValue: false,
          caseKey: 'service_name'
        },
        {
          column: '服务图标',
          key: 'service_icon',
          needKeyValue: false,
          caseKey: 'service_icon'
        },
        {
          column: '接入方式',
          key: 'accessWay',
          needKeyValue: false,
          caseKey: 'accessWay'
        },
        {
          column: '上架标记',
          key: 'shelfLabel',
          needKeyValue: false,
          caseKey: 'shelfLabel'
        },
        {
          column: '服务状态',
          key: 'status',
          needKeyValue: false,
          caseKey: 'status'
        },
        {
          column: '更新时间',
          key: 'update_time',
          needKeyValue: false,
          caseKey: 'update_time'
        },
      ],
      orderConfig: '', // 字段展示和顺序需要的参数
      checked: true,
      statusData: {}, // 状态params
      delId: '', // 删除ID
      tableRow: [ // 所有字段
        {
          column: '使用环境',
          key: 'userEnvironment',
          needKeyValue: false,
          caseKey: 'userEnvironment'
        },
        {
          column: '服务名称',
          key: 'service_name',
          needKeyValue: false,
          caseKey: 'service_name'
        },
        {
          column: '服务图标',
          key: 'service_icon',
          needKeyValue: false,
          caseKey: 'service_icon'
        },
        {
          column: '接入方式',
          key: 'accessWay',
          needKeyValue: false,
          caseKey: 'accessWay'
        },
        {
          column: '上架标记',
          key: 'shelfLabel',
          needKeyValue: false,
          caseKey: 'shelfLabel'
        },
        {
          column: '服务状态',
          key: 'status',
          needKeyValue: false,
          caseKey: 'status',
          isCustomList: [
              {
              label: '已上架',
              value: '1'
              },
              {
              label: '已下架',
              value: '0'
              }
          ]
        },
        {
          column: '更新时间',
          key: 'update_time',
          needKeyValue: false,
          caseKey: 'update_time'
        },
      ]
    }
  },
  computed: {
    // 使用环境下拉列表
    SYHJoptions() {
      const { dictList } = this.$store.state.serviceList;
      if (dictList) {
        const list = dictList.filter(item => item.type === 1);
        return list
      }
      return [];
    },
    // 下拉列表
    JRFSoptions() {
      const { dictList } = this.$store.state.serviceList;
      if (dictList) {
        const list = dictList.filter(item => item.type === 2);
        return list
      }
      return [];
    },
  },
  created() {
    const dispField = this.getSessonValue("serviceListDisplayFied");
    const tableRow = this.getSessonValue("serviceListSortData");
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
    this.getTableData()
    this.init();
  },
  methods: {
    changeComponent(rowData, page) {
      setStore({
        name: "rowData",
        content: rowData,
        type: "session"
      });
      this.$emit("changeComponent", page);
    },
    init() {
      this.$store.dispatch('dictList');
    },
    isStatus(row, key) {
      if (key === 'status') {
        return row[key]  
      }
    },
    // 状态更新
    updateStatus(row) {
      this.noticeDispatch = 'status'
      if (row.status === 0) {
        this.noticeSpec = '上架后，授权用户可查看与使用该服务，';
        this.noitceContent = '请确保服务的可用性！'; // 提示信息
      } else {
        this.noticeSpec = '下架后，授权用户将无法使用查看和使用该服务，'
        this.noitceContent = '请谨慎操作！'; // 提示信息
      }
      this.agreeContent = '确定' // 提示弹窗确认按钮内容
      this.noticeTitle = '提示' // 提示
      this.noticeType = 1
      this.noticeModal = true
      this.statusData =  {
        id: row.id,
        status: row.status === 0 ? 1 : 0,
      };
    },
    handleDelete(row) {
      this.noticeDispatch = 'del'
      this.delId = row.id;
      this.noticeSpec = '删除后，所有用户无法查看与使用该服务，';
      this.noitceContent = '请谨慎操作！'; // 提示信息
      this.agreeContent = '删除' // 提示弹窗确认按钮内容
      this.noticeTitle = '提示' // 提示
      this.noticeType = 1
      this.noticeModal = true
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session"
      });
    },
     // 高级检索
    toHignSearch(res) {
      console.log(res)
      this.hignSearchRes = res
      this.hignModal = false
      this.pageIndex = 1;
      this.getTableData();
    },
    // 搜索
    searchInput() {
      this.hignSearchRes = ''
      this.pageIndex = 1
      this.getTableData()
    },
    // 重置
    resetInput() {
      this.hignSearchRes = ''
      this.pageIndex = 1
      Object.keys(this.formInline).forEach((key) => {
        this.formInline[key] = '';
      })
      this.getTableData()
    },
    // 批量选中项变化
    handleSelectChange(selection) {
      console.log(selection)
      this.selectArrList = selection
    },
    // 确认弹窗
    agreeNotice() {
      let action = ''
      let data
      // 确认状态
      if (this.noticeDispatch === 'status') {
        action = 'serviceUpdateStatus'
        data = this.statusData
      }
      // 确认删除
      if (this.noticeDispatch === 'del') {
        action = 'serviceRemoveData'
        data = { ids: this.delId }
      }
      this.$store.dispatch(
        action,
        data
      ).then((res) => {
        if (res.data.status === 1000) {
          this.getTableData();
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
        } else {
          this.$message.error(res.data.msg);
        }
        this.noticeModal = false
      })
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false
    },
    // 返回上级
    goBack() {
      this.$emit('backHome')
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    addPage() {
      this.$emit('changeComponent', 'DetailsInfo');
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 切换展示字段
    getTableList(value) {
      this.tableDataShow = value;
    },
    // 改变数据排序
    getDataOrder(value) {
      this.orderConfig = value;
      console.log("改变了数据顺序", this.orderConfig);
      this.getTableData();
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true
    },
    handleSizeChange(val) {
      this.pageIndex = 1
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableData()
    },
    // 查询列表
    async getTableData() {
      let dataSortStr = this.orderConfig;
      if (Array.isArray(this.orderConfig)) {
        dataSortStr = this.orderConfig.join(",");
      }
      this.loading = true
      const serviceList = await this.$store.dispatch('serviceInfoList', {
        serviceName: this.formInline.serviceName,
        userEnvironment: this.formInline.userEnvironment,
        accessWay: this.formInline.accessWay,
        status: this.formInline.status,
        dataSortStr: dataSortStr, //数据排序
        advancedSearch: this.hignSearchRes,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      })
      this.loading = false
      if (serviceList.data.status === 1000) {
        if (serviceList.data.result.data.length !== 0) {
          this.tableData = serviceList.data.result.data
          this.totalNum = Number(serviceList.data.result.total)
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex -= 1
            this.getTableData()
          } else {
            this.tableData = []
            this.totalNum = 0
          }
        }
      } else {
        this.tableData = []
        this.totalNum = 0
      }
    },
    getlable(row, key) {
      // console.log(row, key)
      let value = row[key];
      switch (key) {
        case 'status':
          if (row[key] === 0) {
            value = '已下架';
          } else if (row[key] === 1) {
            value = '已上架';
          } else {
            value = '无';
          }
          break;
        default:
          value = row[key];
          break;
      }
      return value;
    },
    viewImage(img) {
      this.imgSrc = img;
      this.ImgDialog = true;
    },
  }
}
</script>

<style lang="scss">
.service-listTwo {
  height: calc(100vh - 84px);
}
.tableThree-heightOthTwo {
  .el-table__body-wrapper {
    height: calc(100vh - 191px) !important;
    .tableThree-height-shu {
      display: inline-block;
      padding: 0 4px;
      position: relative;
      .shu-item {
        position: absolute;
        width: 1px;
        height: 12px;
        background-color: #D4D4D7;
        display: inline-block;
        top: -10px;
      }
    }
  }
  .bigImg {
    color:#2D8CF0;
    cursor: pointer;
  }
  .redCorlo {
    color: #FF4D4F;
  }
  .greenCorlo {
    color: #33CC99;
  }
}
.serviceDialog {
    text-align: center;
  img {
    max-width: 100%;
  }
  .el-dialog__body {
    padding: 10px 0 !important;
  }
}
</style>